import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';

@Component({
  selector: 'g10-responsive-multiselect',
  templateUrl: './responsive-multiselect.provider.html',
  styleUrls: ['./responsive-multiselect.provider.css']
})
export class ResponsiveMultiselectProvider implements OnInit {

  @Input() matFormSize: string = '13px';
  @Input() appearance: string = "outline";
  @Input() _label: string;
  @Input() _required: boolean = true;
  @Input() multiple: boolean = false;
  @Input() selectAllOption: boolean = false;
  @Input('id') inputID: string;
  @Input('disabled') disabledInput: boolean = false;
  @Input('selectOption') enableSelectOption: boolean = false;  // initial option Ex: -- select --
  @Input('showSearch') enableSearch: boolean = false;
  @Input('searchAPI') apiMethod: string;
  @Input('searchKey') paramKey: string;
  @Input('_list') public set dropdownList(val: any) {
    if (val != undefined && val.length > 0) {
      this.enableOptions = false;
      this.dropdownOptions = val;
      this.enableOptions = true;
    } else if (this.apiMethod && this.apiMethod != '') {
      this.getApiData();
    }
  }
  @Input('value') public set selected(val: any) {
    setTimeout(()=>{
    if (val != undefined && val.length > 0) {
      this.dropdownSelectionResult(val, false)
    }
  },1000);
  }
  @Input() mapAction: Function;
  // @Input() mapAction = (res:any)=>res;

  @Output() result = new EventEmitter();

  public selectedInputval: any;

  public selectedOptions: any = [];
  public enableOptions: boolean = true;
  public dropdownOptions: any = [];
  public allSelected: boolean = false;

  /* dropdown search */
  @ViewChild('dropdownSearch') dropdownSearchTextBox: ElementRef;
  dropdownSearchChangeObserver: any;
  public dropdownSearchVal: any = '';

  constructor(
    private api: ApiService,
  ) { }

  ngOnInit(): void {
  }

  // API call
  getApiData(search: any = null) {
    let obj = {};
    if (search) obj[this.paramKey] = search;
    this.api[this.apiMethod](obj).then((res) => {
      if (this.mapAction) this.dropdownOptions = this.mapAction(res); //callback function
    }).catch((err) => {
      this.dropdownOptions = [];
      console.log(err);
    })
  }

  // search
  searchChange(value: string) {
    let searchValue = value.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.dropdownSearchChangeObserver) {
      new Observable(observer => {
        this.dropdownSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 500ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          if (this.apiMethod && this.apiMethod != '') this.getApiData(term);
        });
    }

    this.dropdownSearchChangeObserver.next(searchValue);
  }

  dropdownSelectionResult(data, emit:boolean=true) {
    let result = [];
    let value = data;
    if (!Array.isArray(value)) value = [value];
    else value = [...value];
    try {
      value.map((item) => {
        this.dropdownOptions.map((option) => {
          if (option.value == item && item != 'All') {
            let index = result.findIndex((res) => res.value == option.value);
            if (index == -1 && !option.disabled) {
              result.push(option)
            }
          }
        })
      })
      this.selectedOptions = [...result];
      if (this.multiple) {
        this.selectedInputval = result.map((item) => item.value);
        if (this.selectAllOption && this.dropdownSearchVal == '') {
          this.allSelected = this.checkAllSelected();
          if (!this.allSelected) {
            this.selectedOptions = this.selectedOptions.filter((option) => option.value != 'All');
          }
          else if (this.allSelected) {
            this.selectedOptions.unshift({ name: 'All', value: 'All' });
          }
        }else if(this.selectAllOption && this.dropdownSearchVal != ''){
          this.allSelected = false;
          this.selectedOptions = this.selectedOptions.filter((option) => option.value != 'All');
        }
      }
      if (!this.multiple) this.selectedInputval = data;
      if (emit) this.result.emit(this.selectedInputval);
    } catch (err) {
      console.log(err);
    }
  }

  checkAllSelected() {
    const noOfSelected = this.selectedOptions.length;
    const noOfOptions = this.dropdownOptions.length;
    return ((noOfSelected === noOfOptions) && (this.dropdownSearchVal=='') && this.dropdownOptions.length>0);
  }

  toggleAll(e) {
    let result = [];
    let values = [];
    this.allSelected = e;
    if (e) {
      let obj = { name: 'All', value: 'All' };
      this.dropdownOptions.map((option) => {
        let index = result.findIndex((res) => res.value == option.value);
        if (index == -1 && !option.disabled) {
          result.push(option);
          values.push(option.value)
        }
      });
      if (result.length > 0) {
        result.unshift(obj);
        values.unshift('All');
      }
    }
    if (result.length > 1) this.allSelected = true;
    this.selectedOptions = [...result];
    this.selectedInputval = [...values];
    this.result.emit(this.selectedInputval);
  }

  dropdownSearchClear() {
    this.dropdownSearchTextBox.nativeElement.value = '';
    this.dropdownSearchVal = '';
    if (this.apiMethod && this.apiMethod != '') this.getApiData();
  }

}
